export default __webpack_public_path__ + "static/media/arifkaptanc2.69c6aa4c.jpg";